/**
 * Internal Carlyle FAP funds carry Carlyle report segment permissions (via Financial
 * Reporting / Tax Information services) but have no LP reporting data, so they must not
 * enable the Carlyle reporting menu (LPC-11108). Global ids per entitlements DB.
 */
export const CARLYLE_NON_REPORTING_INTERNAL_FUNDS: readonly string[] = [
  "F000122523", // Carlyle Internal Coinvestment
  "F000122524", // Carlyle Carried Interest
  "F000122525", // Carlyle Equity Pool
  "F000122526", // Carlyle Holdings Units
];

type CarlyleReportingFund = {
  productSegment: string;
  globalId: string;
};

/** A fund enables Carlyle reporting only if it is non-AlpInvest and not an internal FAP fund. */
export const isCarlyleReportingEntitledFund = (fund: CarlyleReportingFund): boolean =>
  fund.productSegment !== "Carlyle AlpInvest" && !CARLYLE_NON_REPORTING_INTERNAL_FUNDS.includes(fund.globalId);
